module.exports = __webpack_public_path__ + "media/images/ringrevenue/arrows-e6aa60643d2866530d88f441c2f79161.png";